import type { OfficeAgent } from './office';
import type { Kpi } from '@hermes-office/shared';

/**
 * F-08: Demo agents no longer contain hermes_base_url or api_key_env.
 * Client code uses AgentPublic which has endpoint_configured: boolean instead.
 */
export const DEMO_AGENTS: OfficeAgent[] = [
  {
    id: 'demo-command',
    name: 'Ares',
    role: 'Command Chief & Orchestrator',
    department: 'command',
    avatar: '⚡',
    soul_summary: 'Mengatur alur kerja tim, mendistribusikan tugas antar agen, dan memantau KPI.',
    hermes_profile: 'ares-command',
    active: 1,
    hired_at: 1728700000000,
    created_at: 1728700000000,
    endpoint_configured: false,
    status: 'idle',
    isDemo: true,
  },
  {
    id: 'demo-social',
    name: 'Maya',
    role: 'Social Media Lead',
    department: 'social',
    avatar: '📱',
    soul_summary: 'Mengelola jadwal posting X/Telegram, riset viral hook, dan copywriting interaktif.',
    hermes_profile: 'maya-social',
    active: 1,
    hired_at: 1728700000000,
    created_at: 1728700000000,
    endpoint_configured: false,
    status: 'idle',
    isDemo: true,
  },
  {
    id: 'demo-sales',
    name: 'Jordan',
    role: 'B2B Sales Specialist',
    department: 'sales',
    avatar: '💼',
    soul_summary: 'Kualifikasi lead inbound, follow up prospek, dan menyusun penawaran bisnis.',
    hermes_profile: 'jordan-sales',
    active: 1,
    hired_at: 1728700000000,
    created_at: 1728700000000,
    endpoint_configured: false,
    status: 'idle',
    isDemo: true,
  },
  {
    id: 'demo-finance',
    name: 'Satoshi',
    role: 'Financial Analyst',
    department: 'finance',
    avatar: '💰',
    soul_summary: 'Audit pembukuan, rekonsiliasi pembayaran, dan penyusunan laporan keuangan.',
    hermes_profile: 'satoshi-finance',
    active: 1,
    hired_at: 1728700000000,
    created_at: 1728700000000,
    endpoint_configured: false,
    status: 'idle',
    isDemo: true,
  },
  {
    id: 'demo-marketing',
    name: 'Chloe',
    role: 'Growth Strategist',
    department: 'marketing',
    avatar: '🚀',
    soul_summary: 'Optimasi landing page, strategi corong akuisisi, dan analisis ROI kampanye.',
    hermes_profile: 'chloe-marketing',
    active: 1,
    hired_at: 1728700000000,
    created_at: 1728700000000,
    endpoint_configured: false,
    status: 'idle',
    isDemo: true,
  },
  {
    id: 'demo-analytics',
    name: 'Ada',
    role: 'Data Scientist',
    department: 'analytics',
    avatar: '📊',
    soul_summary: 'Analisis metrik penggunaan, segmentasi kohor pengguna, dan query data real-time.',
    hermes_profile: 'ada-analytics',
    active: 1,
    hired_at: 1728700000000,
    created_at: 1728700000000,
    endpoint_configured: false,
    status: 'idle',
    isDemo: true,
  },
  {
    id: 'demo-support',
    name: 'Atlas',
    role: 'Support Specialist',
    department: 'support',
    avatar: '🎧',
    soul_summary: 'Merespons pertanyaan pengguna Telegram, troubleshooting cepat, dan eskalasi bug.',
    hermes_profile: 'atlas-support',
    active: 1,
    hired_at: 1728700000000,
    created_at: 1728700000000,
    endpoint_configured: false,
    status: 'idle',
    isDemo: true,
  },
  {
    id: 'demo-hr',
    name: 'Helena',
    role: 'Head of Recruitment & Culture',
    department: 'hr',
    avatar: '🤝',
    soul_summary: 'Merancang SOUL profil agen baru, evaluasi kinerja tim, dan orientasi peran kantor.',
    hermes_profile: 'helena-hr',
    active: 1,
    hired_at: 1728700000000,
    created_at: 1728700000000,
    endpoint_configured: false,
    status: 'idle',
    isDemo: true,
  },
];

export const DEMO_KPIS: Kpi[] = [
  { id: 'kpi-fin-1', department: 'finance', key: 'mrr', label: 'Monthly Recurring Revenue', value: 128500, unit: 'USD', period: '2026-Q3', source: 'manual', source_note: 'Verified from bank statement', created_at: 1728700000000 },
  { id: 'kpi-fin-2', department: 'finance', key: 'server_costs', label: 'Biaya Server VPS', value: 3420, unit: 'USD', period: '2026-Q3', source: 'import', source_note: 'Coolify & cloud metrics', created_at: 1728700000000 },
  { id: 'kpi-fin-3', department: 'finance', key: 'burn_rate', label: 'Burn Rate Proyeksi', value: 18500, unit: 'USD', period: '2026-Q3', source: 'agent', source_note: 'Estimasi agen finance', created_at: 1728700000000 },
  { id: 'kpi-sales-1', department: 'sales', key: 'deals_won', label: 'Deals Won (Q3)', value: 38, unit: 'deals', period: '2026-Q3', source: 'manual', source_note: 'CRM closed won', created_at: 1728700000000 },
  { id: 'kpi-sales-2', department: 'sales', key: 'pipeline_val', label: 'Total Pipeline Value', value: 450000, unit: 'USD', period: '2026-Q3', source: 'import', source_note: 'Stripe & HubSpot sync', created_at: 1728700000000 },
  { id: 'kpi-social-1', department: 'social', key: 'engagement', label: 'Engagement Rate', value: 4.85, unit: '%', period: '2026-W41', source: 'import', source_note: 'Telegram Channel analytics', created_at: 1728700000000 },
  { id: 'kpi-social-2', department: 'social', key: 'impressions', label: 'Mingguan Impressions', value: 52400, unit: 'views', period: '2026-W41', source: 'import', source_note: 'X / Telegram views', created_at: 1728700000000 },
  { id: 'kpi-cmd-1', department: 'command', key: 'system_uptime', label: 'Office Gateway Uptime', value: 99.98, unit: '%', period: '2026-Q3', source: 'import', source_note: 'Systemd & health monitor', created_at: 1728700000000 },
  { id: 'kpi-cmd-2', department: 'command', key: 'task_completion', label: 'Task Success Rate', value: 96.5, unit: '%', period: '2026-Q3', source: 'manual', source_note: 'Dispatcher ledger audit', created_at: 1728700000000 },
  { id: 'kpi-mkt-1', department: 'marketing', key: 'cac', label: 'Customer Acquisition Cost', value: 142, unit: 'USD', period: '2026-Q3', source: 'manual', source_note: 'Ad spend ledger', created_at: 1728700000000 },
  { id: 'kpi-mkt-2', department: 'marketing', key: 'conversion_rate', label: 'Landing Conversion Rate', value: 8.6, unit: '%', period: '2026-Q3', source: 'import', source_note: 'Web telemetry', created_at: 1728700000000 },
  { id: 'kpi-ana-1', department: 'analytics', key: 'query_latency', label: 'P95 Query Latency', value: 38, unit: 'ms', period: '2026-Q3', source: 'import', source_note: 'SQLite performance logs', created_at: 1728700000000 },
  { id: 'kpi-ana-2', department: 'analytics', key: 'data_freshness', label: 'Data Freshness Index', value: 99.9, unit: '%', period: '2026-Q3', source: 'manual', source_note: 'Daily sync check', created_at: 1728700000000 },
  { id: 'kpi-sup-1', department: 'support', key: 'csat', label: 'Customer Satisfaction', value: 4.88, unit: '/5.0', period: '2026-Q3', source: 'manual', source_note: 'Owner ticket feedback', created_at: 1728700000000 },
  { id: 'kpi-sup-2', department: 'support', key: 'avg_resolution', label: 'Avg Resolution Time', value: 2.1, unit: 'menit', period: '2026-Q3', source: 'import', source_note: 'Support ticket queue', created_at: 1728700000000 },
  { id: 'kpi-hr-1', department: 'hr', key: 'active_headcount', label: 'Jumlah Agen Aktif', value: 8, unit: 'agen', period: '2026-Q3', source: 'manual', source_note: 'Office Registry', created_at: 1728700000000 },
  { id: 'kpi-hr-2', department: 'hr', key: 'agent_morale', label: 'Agent Health Index', value: 94, unit: '%', period: '2026-Q3', source: 'manual', source_note: 'Autonomous health check', created_at: 1728700000000 },
];
